import { urlPrefix } from '@/configs/api'
import { paramToUrl, pushAccessCode } from '@/configs/functions'
import { tryAxios } from '@/api/common/auth'
//不能写这里，因为这个文件会被缓存在页面中，所以直接accessCode不会实时变化，storedUser.getAttachAccessCode() 只会执行一次
// const accessCode = storedUser.getAttachAccessCode()

const apiUrl = `${urlPrefix}/export`
//第八批文保单位申报列表 导出到excel
const ExportEighthUnitList = (filename: string) => `${apiUrl}/eighthUnitList/${filename}`
export const exportEighthUnitList = (fileName: string, param?: any) => {
    toDownload(ExportEighthUnitList(fileName), param, fileName)
}
//文保单位列表导出到excel
const ExportUnitList = (filename: string) => `${apiUrl}/unitList/${filename}`
export const exportUnitList = (fileName: string, param?: any) => {
    toDownload(ExportUnitList(fileName), param, fileName)
}
//文保单位坐标检测列表导出到excel
const ExportUnitCoordCheckList = (filename: string) => `${apiUrl}/unitCoordCheckList/${filename}`
export const exportUnitCoordCheckList = (fileName: string, param?: any) => {
    toDownload(ExportUnitCoordCheckList(fileName), param, fileName)
}
//巡查计划导出到excel
const ExportPlanList = (filename: string) => `${apiUrl}/cruisePlan/${filename}`
export const exportPlanList = (fileName: string, param?: any) => {
    toDownload(ExportPlanList(fileName), param, fileName)
}
//巡查日志导出到excel
const ExportCruiseTask = (filename: string) => `${apiUrl}/cruiseTask/${filename}`
export const exportCruiseTask = (fileName: string, param?: any) => {
    toDownload(ExportCruiseTask(fileName), param, fileName)
}
//日常巡查汇总导出到excel
const ExportCruiseSummary = (filename: string) => `${apiUrl}/cruiseSummary/${filename}`
export const exportCruiseSummary = (fileName: string, param?: any) => {
    toDownload(ExportCruiseSummary(fileName), param, fileName)
}
//巡查情况统计导出到excel
const ExportAnalyzeCruiseLogs = (filename: string) => `${apiUrl}/analyzeCruiseLogs/${filename}`
export const exportAnalyzeCruiseLogs = (fileName: string, param?: any) => {
    toDownload(ExportAnalyzeCruiseLogs(fileName), param, fileName)
}
//用户列表导出到excel
const ExportUserList = (filename: string) => `${apiUrl}/userlist/${filename}`
export const exportUserList = (fileName: string, param?: any) => {
    toDownload(ExportUserList(fileName), param, fileName)
}
const ExportDeviceJson = (filename: string) => pushAccessCode(`${apiUrl}/devicejson/${filename}`)
export const getDeviceJson = (filename: string) => {
    return tryAxios({
        method: 'get',
        url: ExportDeviceJson(filename)
        // params: { AccessCode: storedUser.getAttachAccessCode() }
    })
}
export const exportDeviceJson = (fileName: string) => {
    getDeviceJson(fileName).then(
        (response: { data: any }) => {
            var obj = response.data
            downloadJson(obj, fileName + '.json')
        }
    )
}
const downloadJson = (jsonData: any, downloadName: string) => {
    var data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(jsonData))
    let link = document.createElement('a')
    link.style.display = 'none'
    // link.href = 'data:' + jsonData
    link.setAttribute('href', 'data:' + data)
    link.setAttribute('download', downloadName)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
const toDownload = (api: string, param: any, downloadName: string) => {
    // var href = `${api}?AccessCode=${storedUser.getAttachAccessCode()}`
    var href = pushAccessCode(api)
    if (param != null) {
        var query = paramToUrl(param)
        href += `&${query}`
    }

    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = href
    link.setAttribute('download', downloadName)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
export const staticDownload = (filePath: string, downloadName: string) => {
    if (filePath && filePath != '') {
        var href = `${urlPrefix}/StaticFile/download/${downloadName}?path=${filePath}`
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = href
        link.setAttribute('download', downloadName)
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}
export const zipDownload = (batchCode: string, fileName: string) => {
    var href = `${urlPrefix}/StaticFile/zip/${batchCode}/${fileName}`
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = href
    link.setAttribute('download', fileName)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
export const exportTips = (msgBox: any, type: string) => {
    let msg = '正在导出，请稍等。。'
    if (type == 'word') {
        msg = '正在生成word，该过程可能费时较久。<br/>在此期间您可以先进行其他操作。'
    }
    if (type == 'zip') {
        msg = '正在生成文件，压缩过程可能费时较久。<br/>在此期间您可以先进行其他操作。'
    }
    msgBox({
        title: '提示',
        dangerouslyUseHTMLString: true,
        message: msg,
        // duration: 0,
        type: 'warning'
    })
}
